import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';

const ActuatorContext = createContext();

const ActuatorProvider = ({ children }) => {
  const [state, setState] = useState({});

  const setCurrentValue = useCallback((stateId, value) => {
    setState(prev => ({
      ...prev,
      [stateId]: { ...prev[stateId], value },
    }));
  }, []);

  const setCurrentConfirming = useCallback((stateId, confirming) => {
    setState(prev => ({
      ...prev,
      [stateId]: { ...prev[stateId], confirming },
    }));
  }, []);

  const value = useMemo(
    () => ({
      state,
      setCurrentValue,
      setCurrentConfirming,
    }),
    [setCurrentConfirming, setCurrentValue, state],
  );

  return (
    <ActuatorContext.Provider value={value}>
      {children}
    </ActuatorContext.Provider>
  );
};

export const useActuatorContext = () => useContext(ActuatorContext);

ActuatorProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ActuatorProvider;
